var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabnumber({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4318 15C14.3868 9.89297 11.9998 8.54697 11.9998 5.99997V2.99997H12.4998C12.6324 2.99997 12.7596 2.94729 12.8533 2.85352C12.9471 2.75975 12.9998 2.63258 12.9998 2.49997V1.49997C12.9998 1.36736 12.9471 1.24018 12.8533 1.14642C12.7596 1.05265 12.6324 0.999969 12.4998 0.999969H7.49979C7.36718 0.999969 7.24 1.05265 7.14623 1.14642C7.05247 1.24018 6.99979 1.36736 6.99979 1.49997V2.49997C6.99979 2.63258 7.05247 2.75975 7.14623 2.85352C7.24 2.94729 7.36718 2.99997 7.49979 2.99997H7.99979V5.99997C7.99979 8.54697 5.61279 9.89297 3.56779 15C2.91679 16.625 1.24479 19 9.99979 19C18.7548 19 17.0828 16.625 16.4318 15ZM14.8148 16.751C14.1128 16.961 12.7158 17.2 9.99979 17.2C7.28379 17.2 5.88679 16.961 5.18479 16.751C4.93579 16.677 4.83879 16.388 4.92679 16.123C5.14679 15.453 5.56179 14.295 6.33779 13.002C8.23379 9.84297 10.2008 13.499 11.8378 13.499C13.4748 13.499 13.0258 11.938 13.6618 13.002C14.2471 13.9864 14.7203 15.0333 15.0728 16.123C15.1608 16.388 15.0638 16.676 14.8148 16.751Z",
    fill: "#5C5CAB",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabnumber);
export default __webpack_public_path__ + "static/media/labnumber.1891f43e75cfe90edac85584226ff755.svg";
export { ForwardRef as ReactComponent };